import React from 'react'
import { WHITE, RED, HOT_PINK } from '@styles/colors'

const EmergencyPhone = ({ style }) => (
  <svg
    fill='none'
    viewBox='0 0 128 128'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g
      filter='url(#filter0_d)'
      opacity='0.5'
    >
      <circle
        className='outerCircle'
        cx='64'
        cy='60'
        r='60'
        style={style}
      />
    </g>
    <g
      filter='url(#filter1_ddi)'
      opacity='0.9'
    >
      <circle
        cx='63.5'
        cy='59.5'
        fill='url(#paint1_linear)'
        r='43.5'
      />
    </g>
    <path
      d='M58.2284 56.4187C58.496 56.1513 58.7082 55.8337 58.853 55.4843C58.9978 55.1348 59.0723 54.7602 59.0723 54.3819C59.0723 54.0035 58.9978 53.629 58.853 53.2795C58.7082 52.93 58.496 52.6124 58.2284 52.345L55.1727 49.2907C54.6326 48.7508 53.9002 48.4475 53.1366 48.4475C52.3729 48.4475 51.6405 48.7508 51.1004 49.2907L49.4242 50.9669C48.7218 51.6714 48.284 52.5967 48.1849 53.5866C48.0857 54.5764 48.3312 55.5702 48.8799 56.4C53.8119 63.8237 60.1763 70.1881 67.5999 75.12C68.4299 75.6686 69.4238 75.9138 70.4136 75.8144C71.4035 75.715 72.3288 75.2769 73.033 74.5743L74.7106 72.8981C75.2506 72.358 75.5539 71.6256 75.5539 70.8619C75.5539 70.0983 75.2506 69.3659 74.7106 68.8258L71.655 65.7715C71.1149 65.2316 70.3825 64.9283 69.6188 64.9283C68.8551 64.9283 68.1227 65.2316 67.5826 65.7715L66.5646 66.7896C63.1488 63.9801 60.0141 60.8454 57.2046 57.4296L58.2284 56.4187Z'
      stroke={WHITE}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.88'
    />
    <path
      d='M64.72 42.72C69.112 42.72 73.3241 44.4647 76.4297 47.5703C79.5353 50.6759 81.28 54.888 81.28 59.28'
      stroke={WHITE}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.44'
    />
    <path
      d='M64.72 48.48C67.5843 48.48 70.3313 49.6178 72.3567 51.6432C74.3821 53.6686 75.52 56.4156 75.52 59.28'
      stroke={WHITE}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.44'
    />
    <path
      d='M64.72 54.24C66.0567 54.24 67.3386 54.771 68.2838 55.7162C69.229 56.6614 69.76 57.9433 69.76 59.28'
      stroke={WHITE}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.44'
    />
    <defs>
      <filter
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
        height='128'
        id='filter0_d'
        width='128'
        x='0'
        y='0'
      >
        <feFlood
          floodOpacity='0'
          result='BackgroundImageFix'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='2' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
        <feBlend
          in2='BackgroundImageFix'
          mode='normal'
          result='effect1_dropShadow'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow'
          mode='normal'
          result='shape'
        />
      </filter>
      <filter
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
        height='117'
        id='filter1_ddi'
        width='117'
        x='5'
        y='5'
      >
        <feFlood
          floodOpacity='0'
          result='BackgroundImageFix'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='7.5' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.95 0 0 0 0 0.629375 0 0 0 0 0.629375 0 0 0 1 0'
        />
        <feBlend
          in2='BackgroundImageFix'
          mode='normal'
          result='effect1_dropShadow'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='2' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
        />
        <feBlend
          in2='effect1_dropShadow'
          mode='normal'
          result='effect2_dropShadow'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect2_dropShadow'
          mode='normal'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset
          dx='-1'
          dy='-3'
        />
        <feComposite
          in2='hardAlpha'
          k2='-1'
          k3='1'
          operator='arithmetic'
        />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0'
        />
        <feBlend
          in2='shape'
          mode='normal'
          result='effect3_innerShadow'
        />
      </filter>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint0_linear'
        x1='12.64'
        x2='124'
        y1='60'
        y2='60'
      >
        <stop stopColor={RED} />
        <stop
          offset='1'
          stopColor={HOT_PINK}
        />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint1_linear'
        x1='26.264'
        x2='107'
        y1='59.5'
        y2='59.5'
      >
        <stop stopColor={RED} />
        <stop
          offset='1'
          stopColor={HOT_PINK}
        />
      </linearGradient>
    </defs>
  </svg>
)

export default EmergencyPhone
